<template>
    <div class="page-platformDesc">
        <div class="page-platformDesc__content">
            <div class="page-platformDesc__image">
                <picture>
                    <source :srcset="platformItem.image[sourceType]" :type="`image/${sourceType}`"
                            v-for="(sourceType, index) in platformItem.image.sourcesTypes" :key="index">
                    <img :src="platformItem.image.jpg" :alt="platformItem.title"/>
                </picture>
            </div>
            <div class="page-platformDesc__info">
                <div class="rate">
                    <h2>{{ $t('front.provider.titles.rate') }}</h2>
                    <div class="rate__list">
                        <img :src="ratingImage(index)" alt="rating" v-for="index in 5">
                    </div>
                </div>
                <div class="jackpots">
                    <h2 v-text="$t('front.provider.titles.jackpots')"/>
                    <p v-text="platformJackpot"/>
                </div>
                <div class="desc">
                    <h2>{{ $t('front.provider.titles.info') }}</h2>
                    <div class="desc__content" v-html="platformItem.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlatformItemDescription",

    props: ['platformItem'],

    computed: {
        platformJackpot() {
            return this.platformItem && this.platformItem.isJackpot ? this.$t('front.game.info.jackpot_status.yes') : this.$t('front.game.info.jackpot_status.no');
        },
    },

    methods:{
        ratingImage(index){
          return index <= this.platformItem.rating ? '/public/icons/star-yes.svg' : '/public/icons/star-no.svg';
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/PlatformItemDescription"
</style>